module.exports = __webpack_public_path__ + "media/images/lb/572-13649a714a36fcc5433fba726b600060.svg";